module.exports = __webpack_public_path__ + "img/0107.f8a90ec8.png";